import { Component, ElementRef, Input, OnInit, ViewChild, signal } from '@angular/core';
import { Router } from '@angular/router';
import { map } from 'rxjs';
import { ServiceSearchResult } from 'src/app/models/searchresult.model';
import { DrupalService } from 'src/app/services/drupal.service';
import { stringSubstr } from 'src/app/utils.ts/helpers';

interface Card {
  id: string;
  title: string;
  description: string;
  alias: string;
  related_tags: string[];
}

interface Data {
  field_conditional?: { content_type: string };
  tag_related_tags?: string[];
  related_tags?: Card[];
  card_loader_cards?: Card[];
}

@Component({
  selector: 'app-card-loader',
  templateUrl: './card_loader.component.html',
  styleUrls: ['./card_loader.component.scss']
})
export class CardLoaderComponent implements OnInit {
  @Input() data: Data | any;
  @ViewChild('top') scrollToTop: ElementRef | undefined;

  isArgomentiPage: boolean = false;
  isNewsPage: boolean = false;
  isLoading: boolean = true;
  isServicePage: boolean = false;
  isDocumentPage: boolean = false;
  titleIsPresent: boolean = true
  isPersonPage: boolean = false;
  isOrgUnitPage: boolean = false;
  relatedTags: Card[] = [];
  searchResults = signal<ServiceSearchResult[]>([]);
  totalResult: number = 0;
  dataElement = "";
  paginatorVisible: boolean = true;
  currentPage: number = 0;
  totalPages: number = 0;
  pageLimit: number = 9;
  stringSubstr = stringSubstr

  constructor(private drupalService: DrupalService, private router: Router) {

  }

  ngOnInit(): void {

    const url = this.getUrl();
    this.updateDataElementBasedOnRoute(url);
    switch (this.data?.field_conditional?.content_type) {
      case 'person':
        this.handlePersonCase();
        break;
      case 'tag':
        this.handleTagCase();
        break;
      case 'news':
        this.processNews();
        break;
      case 'service':
        this.processServices();
        break;
      case 'public_document':
        this.processDocuments();
        break;
      case 'org_unit':
        this.handleOrgUnits();
        break;
      default:
        this.handleDefaultCase();
    }
  }

  updateDataElementBasedOnRoute(routeValue: string): void {
    if (routeValue.includes('argomenti')) {
      this.dataElement = 'topic-element';
    } else if (routeValue.includes('servizi')) {
      this.dataElement = 'service-category-link';
    } else if (routeValue.includes('servizi/')) {
      this.dataElement = 'service-link';
    } else {
      this.dataElement = '';
    }
  }

  getUrl(): string {
    const fullUrl = this.router.url;
    return fullUrl;
  }
  private handlePersonCase(): void {
    this.scrollToTop?.nativeElement.scrollIntoView({ behavior: "smooth" });
    this.isPersonPage = true;
    this.isLoading = true;
    this.drupalService.getPersonByCat(this.data.field_conditional.taxonomy_value, this.currentPage, this.pageLimit).subscribe({
      next: (res: any) => {
        this.totalPages = Math.ceil(res.meta.count / this.pageLimit)
        this.data.card_loader_cards = res.data
        this.isLoading = false;
      },
      error: console.error
    });
  }
  private handleTagCase(): void {
    this.scrollToTop?.nativeElement.scrollIntoView({ behavior: "smooth" });
    this.isArgomentiPage = true;
    this.isLoading = true;
    this.drupalService.getRelatedTags().subscribe({
      next: (res: any) => {
        this.data.card_loader_cards = res.data.map((tag: any) => this.mapTagToCard(tag));
        this.isLoading = false;
      },
      error: console.error

    })
  }

  private handleOrgUnits(): void {
    this.scrollToTop?.nativeElement.scrollIntoView({ behavior: "smooth" });
    this.isLoading = true;
    this.isOrgUnitPage = true;
    this.drupalService.getOrgUnitByTag(this.data.field_conditional.taxonomy_value, this.currentPage, this.pageLimit).subscribe({
      next: (res: any) => {
        this.totalPages = Math.ceil(res.meta.count / this.pageLimit)
        this.data.card_loader_cards = res.data
        this.isLoading = false;
      },
      error: console.error
    });
  }

  private mapTagToCard(tag: any): Card {
    return {
      id: tag.id,
      title: tag?.title || '',
      description: tag?.tag_body?.summary || '',
      alias: tag?.path?.alias || '',
      related_tags: tag?.tag_related_tags || [],
    };
  }

  private handleDefaultCase(): void {
    this.isLoading = false;
  }

  private processNews(): void {
    this.scrollToTop?.nativeElement.scrollIntoView({ behavior: "smooth" });
    this.isNewsPage = true;
    this.drupalService.getNewsByCat(this.data.field_conditional.taxonomy_value, this.currentPage, this.pageLimit).subscribe({
      next: (res: any) => {
        this.totalPages = Math.ceil(res.meta.count / this.pageLimit)
        this.data.card_loader_cards = res.data
        this.isLoading = false;
      },
      error: console.error
    });
  }

  private processDocuments(): void {
    this.isArgomentiPage = false;
    this.isNewsPage = false;
    this.isDocumentPage = true;
    this.scrollToTop?.nativeElement.scrollIntoView({ behavior: "smooth" });
    this.drupalService.getDocumentByCat(this.data.field_conditional.taxonomy_value, this.currentPage, this.pageLimit).subscribe({
      next: (res: any) => {
        this.totalPages = Math.ceil(res.meta.count / this.pageLimit)
        this.data.card_loader_cards = res.data
        this.isLoading = false;
      },
      error: console.error
    });
  }
  private processServices(): void {
    this.scrollToTop?.nativeElement.scrollIntoView({ behavior: "smooth" });
    this.isServicePage = true;
    this.drupalService.ESQuerySearch('service', {
      "from": 0,
      "size": 30,
      "query": {
        "bool": {
          "must": [
            ...(this.data.field_conditional.content_type ? [{ "term": { "data.type": this.data.field_conditional.content_type } }] : []),
            ...(this.data.field_conditional.taxonomy_value ? [{ "term": { "data.service_category.drupal_internal__tid": this.data.field_conditional.taxonomy_value } }] : []),
            ...(this.data.status ? [{ "term": { "data.status": true } }] : []),
          ]
        }
      }
    }).pipe(
      map((res: any) => {
        this.totalResult = res?.hits?.total?.value;

        const adaptedData = res.hits.hits.map((item: any) => {
          return {
            type: item.data.type,
            title: item.data.title,
            shortDescription: item.data.service_short_description,
            category: item.data.service_category,
            path: item?.data?.path?.alias,
          };
        });
        return adaptedData;

      })
    ).subscribe({
      next: (result: any) => {
        if (this.searchResults().length) {
          this.searchResults.update(searchArr => {
            searchArr = [...searchArr, ...result];
            //this.startResultIndex = searchArr.length;
            return searchArr;
          });
        } else {
          this.searchResults.set(result);

          //this.startResultIndex = result.length;
        }
        //this.data.card_loader_cards = [...this.data.card_loader_cards, ...res.hits.hits.map((item: any) => item.data)];
        this.isLoading = false;
      },
      error: console.error
    });
  }
  search(searchTerm: string, newTerm: boolean = false) {
    console.log("Searching..");
    this.drupalService.ESQuerySearch('service', {
      "query": {
        "bool": {
          "must": [
            ...(this.data.field_conditional.taxonomy_value ? [{ "term": { "data.service_category.drupal_internal__tid": this.data.field_conditional.taxonomy_value } }] : []),
            ...(searchTerm ? [{ "match": { "data.title": searchTerm } }] : []),

          ]
        }
      }
    }
    ).pipe(
      map((res: any) => {
        this.totalResult = res?.hits?.total?.value;

        const adaptedData = res.hits.hits.map((item: any) => {
          return {
            type: item.data.type,
            title: item.data.title,
            shortDescription: item.data.service_short_description,
            category: item.data.service_category,
            path: item?.data?.path?.alias,
          };
        });
        return adaptedData;

      })
    ).subscribe({
      next: (result: any) => {

        this.searchResults.set(result);

        this.isLoading = false;
      },
      error: console.error
    });
  }

  onSearch(term: string, ct: string = 'news') {
    let categoryMap: { [key: string]: string } = {
      'news': 'news_type',
      'public_document': 'public_document_type',
      'public_person': 'person_type',
      'org_unit': 'org_unit_type',
    }
    if (term === '') {
      this.paginatorVisible = true;
      return this.ngOnInit()
    }
    this.drupalService.ESQuerySearch(ct, {
      "from": 0,
      "size": 30,
      "query": {
        "bool": {
          "must": [
            ...(this.data.field_conditional.taxonomy_value ? [{ "term": { [`data.${categoryMap[ct]}.drupal_internal__tid`]: this.data.field_conditional.taxonomy_value } }] : []),
            ...(term ? [{
              "multi_match": {
                "query": term,
                "type": "phrase_prefix",
                "fields": [
                  "data.title^50",
                  "*"
                ]
              }
            }] : []),
            ...(this.data.status ? [{ "term": { "data.status": true } }] : []),
          ]
        }
      }
    }
    ).subscribe({
      next: (data: any) => {
        this.data.card_loader_cards = data.hits.hits.map((item: any) => {
          this.paginatorVisible = false;
          this.isLoading = false;
          return item.data
        });
      },
      error: console.error
    });
  }

  onPageChange(page: number, ct: string = 'news') {
    this.isLoading = true;
    const categoryMethodMap: { [key: string]: keyof DrupalService } = {
      'news': 'getNewsByCat',
      'org_unit': 'getOrgUnitByTag',
      'public_person': 'getPersonByCat',
      'public_document': 'getDocumentByCat',
    };
  
    // Get the appropriate method for the given type
    const methodName = categoryMethodMap[ct];
  
    // Validate method existence
    if (!methodName || typeof this.drupalService[methodName] !== 'function') {
      console.error(`Invalid category type: ${ct}. Method not found.`);
      return;
    }
  
    this.data.card_loader_cards = [];
    this.scrollToTop?.nativeElement.scrollIntoView({ behavior: "smooth" });
  
    // Call the appropriate method dynamically
    (this.drupalService[methodName] as Function)(
      this.data.field_conditional.taxonomy_value,
      (page - 1) * this.pageLimit,
      this.pageLimit
    ).subscribe((data: any) => {
      this.data.card_loader_cards = data.data;
      this.currentPage = page;
      this.totalPages = Math.ceil(data.meta.count / this.pageLimit);
      this.isLoading = false;
    });
  }
  
}
